import { useSearchParams } from "react-router-dom"
import { useGetComponentOptions } from "hooks/api/quotation/quotations.hook"
import { SeriesAndDelivery } from "./layout/SeriesAndDelivery/SeriesAndDelivery"
import { SlopeAndOptions } from "./layout/SlopeAndOptions/SlopeAndOptions"
import { CountertopSeries } from "./layout/CountertopSeries/CountertopSeries"
import { useErefConfigurationSave } from "./useErefConfigurationSave"
import type { TErefWithFurniture } from "types/elevationReferences.type"
import type { TQuotationDetail } from "types/quotations.type"

type Props = { eref: TErefWithFurniture; configuration?: TQuotationDetail["configuration"] }

export const ConfigurationTab = ({ eref, configuration }: Props) => {
	const [searchParams] = useSearchParams()
	const quotationId = searchParams.get("quotationID")

	const { save, isPending } = useErefConfigurationSave(eref)

	const seriesId = eref.estimation_config?.series_override_id ?? configuration?.series_id ?? undefined
	const { data: componentOptions } = useGetComponentOptions({
		seriesId: seriesId ?? undefined,
		components: ["case_color", "countertop_series_and_colors"],
		quotationId: quotationId ? Number(quotationId) : undefined,
	})

	return (
		<div>
			<SeriesAndDelivery
				eref={eref}
				save={save}
				isPending={isPending}
				deliveryDates={configuration?.delivery_dates ?? []}
			/>
			<SlopeAndOptions
				eref={eref}
				save={save}
				isPending={isPending}
				caseColorOptions={componentOptions?.case_color ?? []}
			/>
			<CountertopSeries
				eref={eref}
				save={save}
				isPending={isPending}
				countertopOptions={componentOptions?.countertop_series_and_colors ?? []}
			/>
		</div>
	)
}
